import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "dataset-list-container" }
const _hoisted_2 = { class: "search-container" }
const _hoisted_3 = { class: "date-condition" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "date-label" }, "Date", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "date-label" }, "To", -1)
const _hoisted_6 = { class: "select-container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "select-label" }, "Country", -1)
const _hoisted_8 = { class: "select-container" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "select-label" }, "Journal", -1)
const _hoisted_10 = { class: "select-container" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "select-label" }, "Tissue", -1)
const _hoisted_12 = { class: "select-container" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "select-label" }, "Species", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "mid-separator" }, null, -1)
const _hoisted_16 = { class: "right-side" }
const _hoisted_17 = { class: "name-search-container" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Search ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" View ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_input, {
          modelValue: _ctx.startDate,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_5,
        _createVNode(_component_el_input, {
          modelValue: _ctx.endDate,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endDate) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_el_select, {
          modelValue: _ctx.selectedCountry,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCountry) = $event)),
          class: "select"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryList, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.name,
                label: item.name,
                value: item.name
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_el_select, {
          modelValue: _ctx.selectedJournal,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedJournal) = $event)),
          class: "select"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.journalList, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.name,
                label: item.name,
                value: item.name
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(_component_el_select, {
          modelValue: _ctx.selectedTissue,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedTissue) = $event)),
          class: "select"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tissueList, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.name,
                label: item.name,
                value: item.name
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_el_select, {
          modelValue: _ctx.selectedSpecies,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedSpecies) = $event)),
          class: "select"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.speciesList, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.name,
                label: item.name,
                value: item.name
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.searchDataset
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _hoisted_15,
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.searchName,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchName) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          type: "text",
          class: "name-search-button",
          onClick: _ctx.searchDatasetByName
        }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode(_component_el_table, {
        data: _ctx.currentPageData,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            fixed: "",
            label: "Dataset Name",
            width: "480"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_popover, {
                effect: "light",
                trigger: "hover",
                placement: "top",
                width: "auto"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(scope.row.name_short), 1)
                ]),
                reference: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.name_long), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "date",
            label: "Date",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "doi",
            label: "doi",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "country",
            label: "Country",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "journal",
            label: "Journal",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "biotech",
            label: "Biotech",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "species",
            label: "Species",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "tissue",
            label: "Tissue",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            prop: "n_unit",
            label: "N_Unit",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "Operations",
            width: "240"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                size: "small",
                onClick: ($event: any) => (_ctx.selectDataset(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_el_pagination, {
        layout: "prev, pager, next",
        "page-size": _ctx.pageSize,
        total: _ctx.datasetListData.length,
        "current-page": _ctx.currentPage,
        onCurrentChange: _ctx.gotoPage
      }, null, 8, ["page-size", "total", "current-page", "onCurrentChange"])
    ])
  ]))
}